import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import './PrivacyPolicy.css';

function PrivacyPolicy() {
  const navigate = useNavigate();

  return (
    <div className="privacy-policy-page">
      <div className="privacy-policy-container">
        <button className="privacy-policy-back" onClick={() => navigate(-1)}>
          <ArrowLeft size={20} />
          Назад
        </button>
        
        <div className="privacy-policy-content">
          <h1>Политика в отношении обработки персональных данных</h1>
          
          <section>
            <h2>1. Общие положения</h2>
            <p>
              Настоящая Политика в отношении обработки персональных данных (далее — «Политика») 
              разработана в соответствии с Федеральным законом от 27.07.2006 № 152-ФЗ «О персональных данных» 
              и определяет порядок обработки и защиты персональных данных пользователей сервиса Pikly 
              (далее — «Сервис»), принадлежащего ООО "САХА КОНТЕНТ" (далее — «Оператор»).
            </p>
          </section>

          <section>
            <h2>2. Основные понятия</h2>
            <p>
              <strong>Персональные данные</strong> — любая информация, относящаяся к прямо или косвенно 
              определенному или определяемому физическому лицу (субъекту персональных данных).
            </p>
            <p>
              <strong>Обработка персональных данных</strong> — любое действие с персональными данными, 
              включая сбор, запись, систематизацию, накопление, хранение, уточнение, извлечение, 
              использование, передачу, обезличивание, блокирование, удаление, уничтожение.
            </p>
          </section>

          <section>
            <h2>3. Категории обрабатываемых персональных данных</h2>
            <p>Оператор обрабатывает следующие категории персональных данных:</p>
            <ul>
              <li>Фамилия, имя, отчество</li>
              <li>Адрес электронной почты</li>
              <li>Номер телефона</li>
              <li>Данные для входа в систему (логин, пароль)</li>
              <li>IP-адрес</li>
              <li>Информация о браузере и устройстве</li>
              <li>Данные о платежных операциях</li>
              <li>Данные, собираемые с помощью cookies и аналогичных технологий</li>
            </ul>
          </section>

          <section>
            <h2>3.1. Использование cookies</h2>
            <p>
              Сайт использует cookies — небольшие текстовые файлы, размещаемые на устройстве пользователя 
              для обеспечения работы сайта, улучшения пользовательского опыта и сбора аналитической информации.
            </p>
            
            <h3>Типы используемых cookies:</h3>
            <ul>
              <li>
                <strong>Обязательные cookies</strong> — необходимы для базовой функциональности сайта 
                (авторизация, безопасность, сохранение настроек). Эти cookies не могут быть отключены.
              </li>
              <li>
                <strong>Аналитические cookies</strong> — используются для сбора статистики посещений 
                и улучшения пользовательского опыта. Помогают понять, как пользователи взаимодействуют с сайтом.
              </li>
              <li>
                <strong>Маркетинговые cookies</strong> — используются для показа релевантной рекламы 
                и отслеживания эффективности рекламных кампаний.
              </li>
            </ul>

            <p>
              Пользователь может управлять настройками cookies через специальное модальное окно, 
              которое появляется при первом посещении сайта, или в любое время через настройки в футере сайта.
            </p>

            <p>
              Большинство браузеров также позволяют управлять cookies через настройки браузера 
              (блокировать, удалять, предупреждать о сохранении).
            </p>
          </section>

          <section>
            <h2>4. Цели обработки персональных данных</h2>
            <p>Оператор обрабатывает персональные данные в следующих целях:</p>
            <ul>
              <li>Предоставление доступа к функционалу Сервиса</li>
              <li>Обработка запросов и обращений пользователей</li>
              <li>Обработка платежей</li>
              <li>Улучшение качества Сервиса</li>
              <li>Соблюдение требований законодательства</li>
            </ul>
          </section>

          <section>
            <h2>5. Правовые основания обработки</h2>
            <p>
              Обработка персональных данных осуществляется на основании:
            </p>
            <ul>
              <li>Согласия субъекта персональных данных</li>
              <li>Договора, стороной которого является субъект персональных данных</li>
              <li>Требований законодательства Российской Федерации</li>
            </ul>
          </section>

          <section>
            <h2>6. Сроки обработки персональных данных</h2>
            <p>
              Персональные данные обрабатываются в течение срока, необходимого для достижения целей обработки, 
              или до момента отзыва согласия на обработку персональных данных.
            </p>
          </section>

          <section>
            <h2>7. Меры по защите персональных данных</h2>
            <p>
              Оператор принимает необходимые правовые, организационные и технические меры для защиты 
              персональных данных от неправомерного доступа, уничтожения, изменения, блокирования, 
              копирования, предоставления, распространения, а также от иных неправомерных действий.
            </p>
          </section>

          <section>
            <h2>8. Права субъектов персональных данных</h2>
            <p>Субъект персональных данных имеет право:</p>
            <ul>
              <li>Получать информацию, касающуюся обработки его персональных данных</li>
              <li>Требовать уточнения, блокирования или уничтожения персональных данных</li>
              <li>Отозвать согласие на обработку персональных данных</li>
              <li>Обжаловать действия или бездействие Оператора в уполномоченный орган</li>
            </ul>
          </section>

          <section>
            <h2>9. Контактная информация</h2>
            <p>
              По всем вопросам, связанным с обработкой персональных данных, вы можете обращаться:
            </p>
            <p>
              <strong>ООО "САХА КОНТЕНТ"</strong><br />
              ИНН 1400007690, ОГРН 1221400004297<br />
              Регистрационный номер 14-25-002616 в Реестре операторов РКН
            </p>
          </section>

          <section>
            <p className="privacy-policy-date">
              Дата последнего обновления: {new Date().toLocaleDateString('ru-RU')}
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;

